import React from 'react';
import { useTranslation } from 'react-i18next';
import { AdditionalInformation } from '@1po/1po-bff-fe-spec/generated/catalog/references/dh/model/Reference';
import { Tooltip } from 'antd-v5';
import { InfoCircleIcon } from 'assets/icons';
import { Flex, Icon, Text } from 'UI';

const AdditionalInfoTooltip = ({ additionalInformation }: { additionalInformation?: AdditionalInformation[] }) => {
  const { t } = useTranslation();

  if (!additionalInformation || additionalInformation.length === 0) {
    return null;
  }

  return (
    <Tooltip
      title={
        <>
          <Text type={'card_title_dark'}>{t('catalog.details.additional_information', 'Additional information')}</Text>
          <Flex direction={'column'} gap={5}>
            {additionalInformation.map(({ title, description }) => (
              <Flex key={title} gap={5}>
                <Text type="lg" bold color="white" transform={'capitalize'}>
                  {title?.toLowerCase() ?? ''}
                </Text>
                <Text type="base" color="white" transform={'capitalize'}>
                  {description?.toLowerCase()}
                </Text>
              </Flex>
            ))}
          </Flex>
        </>
      }
    >
      <Icon IconComponent={InfoCircleIcon} size={16} />
    </Tooltip>
  );
};

export default AdditionalInfoTooltip;
